import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Validators, Editor, Toolbar, ToolbarDropdown } from 'ngx-editor';
import { SessionDataService } from 'src/app/services/session-data.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { TextSelection, EditorState, Transaction } from 'prosemirror-state';
import { DOMParser } from 'prosemirror-model';
import { keymap } from 'prosemirror-keymap';
import { inputRules, InputRule } from 'prosemirror-inputrules';
import { Plugin } from 'prosemirror-state';
import { splitBlock } from 'prosemirror-commands';
import { customSchema } from '../../../../../custom-schema'
import { EmailEditorComponent } from 'angular-email-editor';
import { GeoService, Suggestion } from 'src/app/services/geo.service';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';


@Component({
  selector: 'app-modal-send-email',
  templateUrl: './modal-send-email.component.html',
  styleUrls: ['./modal-send-email.component.css'],
  encapsulation: ViewEncapsulation.None,

})
export class ModalSendEmailComponent {
  options: EmailEditorComponent['options'] = {
    version: 'latest',
    appearance: {
      theme: 'modern_dark',
    },
    fonts: {
      showDefaultFonts: false,
      customFonts: [
        {
          label: "Playfair Display",
          value: "'Playfair Display',serif",
          url: "https://fonts.googleapis.com/css?family=Playfair+Display:400,700",
        },
        {
          label: "Montserrat",
          value: "'Montserrat',sans-serif",
          url: "https://fonts.googleapis.com/css?family=Montserrat:400,700",
        },
        {
          label: "Inter",
          value: "'Inter',sans-serif",
          url: "https://fonts.googleapis.com/css?family=Inter:400,700",
        },
      ],
    },



    // Aquí se configura el valor predeterminado para el contentWidth
    tools: {
      bodies: {
        properties: {
          contentWidth: {
            editor: {
              defaultValue: '690px'
            }
          }
        }
      }
    }
  };


  checkbox = false



  @ViewChild(EmailEditorComponent)
  private emailEditor!: EmailEditorComponent;

  editorLoaded(event: any): void {
    // Aquí podrías cargar un diseño inicial si lo requieres
    console.log('Editor loaded', event);
    this.emailEditor.editor.setBodyValues({
      contentWidth: '690px' // or you can use percentage like "50%"
    });
  }

  editorReady(event: any): void {
    console.log('Editor ready', event);

  }

    private get unlayer() {
    return this.emailEditor.editor;
  }

  cityCtrl = new FormControl('');
  selectedLocation: Suggestion | null = null;
  private citySub!: Subscription;

  onInput() {
    const v: string = this.cityCtrl.value;
    const match = this.suggestions.find(s => s.label === v);
    this.selectedLocation = match || null;
  }


  exportEditorHtml(callback: (html: string, design: any) => void): void {
    this.emailEditor.editor.exportHtml((data: { design: any; html: string; }) => {
      const parser = new window.DOMParser();
      const doc = parser.parseFromString(data.html, 'text/html');
      const bodyContent = doc.body.innerHTML;
      callback(bodyContent, data.design);
    });
  }

toolbar: Toolbar = [
  ['bold', 'italic', 'underline', 'strike'],
  ['code', 'blockquote'],
  ['ordered_list', 'bullet_list'],
  [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  ['link', 'image', 'video' as any], // Forzamos el tipo para "video"
  ['text_color', 'background_color'],
  ['align_left', 'align_center', 'align_right', 'align_justify'],
  [{ fontFamily: ['Arial', 'Verdana', 'Times New Roman', 'Courier New'] } as any],
  [{ fontSize: ['10px', '12px', '14px', '16px', '18px', '20px'] } as any],
  ['insert_button' as any] // Forzamos el tipo para "insert_button"
];
  email = {
    senderMail: '',
    subject: '',
    recipient: '',
    content: '',
    category: '',
    design: '',
    campaign: {
      subcat: '',
      sector: '',
      ubication: ''
    }
  };
  selectedAccount: string;

  namesArray = []
  suggestions$: Observable<Suggestion[]>;

  constructor(private dialogRef: MatDialogRef<ModalSendEmailComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  public userData: UserDataService, private renderer: Renderer2, private geo: GeoService) {
      this.data.contacts.forEach((contact) => {
        if(contact.email){
          this.namesArray.push(contact.email);
        }
      })

    this.email.recipient = this.namesArray.join(', ');


  }


  sector: any

  suggestions: Suggestion[] = [];

  ngOnInit(): void {
    this.citySub = this.cityCtrl.valueChanges.pipe(
      debounceTime(300),
      switchMap(val => this.geo.searchLocations(val))
    ).subscribe(list => {
      this.suggestions = list;
      if (!this.cityCtrl.value) this.selectedLocation = null;
    });

    this.getMailsAccounts();
    this.getSavedMails();
    this.getAllSubcats();
  }


  ngOnDestroy(): void {
    this.citySub?.unsubscribe();

  }

  onClose(): void {
    this.dialogRef.close();
  }
  invalidEmails: string[] = []; // Array para almacenar correos inválidos
  validateEmails(input: string): void {
    // Reemplazar cada espacio con una coma
    let formattedInput = input.replace(/\s+/g, ',');

    // Eliminar comas consecutivas
    formattedInput = formattedInput.replace(/,+/g, ',');

    // Eliminar comas al principio o al final
    formattedInput = formattedInput.replace(/^,|,$/g, '');

    // Actualizar el campo con la estructura corregida
    this.email.recipient = formattedInput;

    console.log('Campo formateado:', this.email.recipient);
  }

  accounts = []
  getMailsAccounts(){

    this.userData.getMailsAccounts().subscribe((data: any) => {
      this.accounts = data
    })

  }


  onAccountSelected(event){
    console.log(event)

    this.selectedAccount = event;
  }


  isAddingNewCategory: boolean = false;
  categories: string[] = [];

  newCategory: string = '';


  onCategoryChange(selected: string) {
    if (selected === 'new') {
      this.isAddingNewCategory = true;
    } else {
      // Asigna la categoría seleccionada directamente al correo
      this.email.category = selected;
    }
  }

  selectExistent(){
    this.isAddingNewCategory = false;
  }

  // Cuando se pierde el foco del input, se guarda la nueva categoría
  onNewCategoryBlur() {
    if (this.newCategory.trim() !== '') {
      // Asigna la nueva categoría al correo, sin agregarla a la lista global
      this.email.category = this.newCategory.trim();
    }
  }

  // Método que podría servir para guardar la categoría actual o realizar alguna acción adicional
  saveEmail() {
    // Por ejemplo, guardar la categoría seleccionada o la nueva categoría en el servidor
    console.log('Categoría guardada');
    console.log(this.email)




    this.exportEditorHtml((editorContent: string,  editorDesign: any) => {
      // Aquí, si el backend ya se encarga de agregar el doctype y el head,
      // puedes enviar solo el contenido central.
      this.email.content = editorContent;
      this.email.senderMail = this.selectedAccount; // Asume que lo seleccionaste previamente
      this.email.design = editorDesign

    this.userData.saveEmail(this.email).subscribe((data: any) => {
      console.log("Enviado")




      const savedEmail = data

      if (!savedEmail.id) {
        savedEmail.id = new Date().getTime();
      }

      const category = savedEmail.category;
      // Actualiza la variable mailsGrouped: si la categoría existe, se agrega el email;
      // si no, se crea un nuevo grupo y se agrega la categoría a la lista.
      if (this.mailsGrouped[category]) {
        this.mailsGrouped[category].push(savedEmail);
      } else {
        this.mailsGrouped[category] = [savedEmail];
        if (!this.categories.includes(category)) {
          this.categories.push(category);
        }
      }

      console.log(this.mailsGrouped)

    })

  })
}

  getSavedMails(){
    this.userData.getSavedMails().subscribe((data: any) => {
      this.adjustCats(data)
    })




  }
  mailsGrouped = {}
  adjustCats(data){
    this.mailsGrouped = data;
    this.categories = Object.keys(data)
  }

  importMail(mail) {
    console.log(mail);
    this.email.subject = mail.title;
    this.email.content = mail.mail;
    if (mail.design) {
      try {
        const designObj = typeof mail.design === 'string'
                            ? JSON.parse(mail.design)
                            : mail.design;
        // Carga el diseño en el editor
        this.emailEditor.editor.loadDesign(designObj);
      } catch (error) {
        console.error('Error al parsear el JSON del diseño:', error);
      }
    }
  }

allSubcats
  getAllSubcats(): void{
    this.userData.getAllSubcategories().subscribe((data: any) => {
      this.allSubcats = data
    })
  }
  searchText: string = '';
  searchSubcatCampaign: string = '';

  filteredSubcats: any[] = [];
  filteredSubcatsCampaign: any[] = [];

  // Subcategoría seleccionada
  selectedSubcat: any = null;
  selectedSubcatCampaign: any = null;

  // Código HTML generado
  generatedCode: string = '';

  // Indica si se copió correctamente el código
  copySuccess: boolean = false;

  filterSubcats() {
    const search = this.searchText.toLowerCase();
    this.filteredSubcats = this.allSubcats.filter(subcat =>
      subcat.name.toLowerCase().includes(search)
    );
  }
  filterSubcatsCampaign() {
    const search = this.searchSubcatCampaign.toLowerCase();
    this.filteredSubcatsCampaign = this.allSubcats.filter(subcat =>
      subcat.name.toLowerCase().includes(search)
    );
  }
  selectSubcatCampaign(subcat: any) {
    this.selectedSubcatCampaign = subcat;
    this.searchSubcatCampaign = subcat.name;
    this.filteredSubcatsCampaign = [];
  }
  selectSubcat(subcat: any) {
    this.selectedSubcat = subcat;
    this.searchText = subcat.name;
    this.filteredSubcats = [];
    this.generateCode();
    this.copyToClipboard();
  }
  displayFn(s?: Suggestion): string {
    return s ? s.label : '';
  }

  generateCode() {
    // Intentamos parsear la propiedad "domains" (viene como string JSON)
    // Genera el código completo de la tarjeta con estilos en línea
    this.generatedCode = `
<a href="https://alteapec.com/flyer/${this.selectedSubcat.name}" style="text-decoration: none">
<div style="box-shadow: 0 20px 31px 7px #00000014, 0 20px 31px 7px 0#00000017, 0 20px 31px 7px #00000005;
background-color: #e7e7e7; border: 2px solid #ededed; overflow: hidden; border-top: 12px solid #CB0003; border-top-left-radius: 9px;
    border-top-right-radius: 9px;">
  <div style="position: relative;">
    <img src="https://pecblobs.blob.core.windows.net/funnel-images/image_subcat_${this.selectedSubcat.id}.png"
    alt="Course Image" style="aspect-ratio: 2/1; display: block; width: 100%; height: auto; object-fit: cover;">
  </div>
  <div style="display: table; width: 100%; height: 90px; background-color: white;">
    <div style="display: table-cell; vertical-align: middle; text-align: center; padding: 9px;">
      <span style="color: grey; font-size: 19px;">Technical <b style="color: #444">Communication Skills</b></span><br>
      <span style="color: #CB0006; font-size: 21px; font-weight: 600; line-height: 1;">${this.selectedSubcat.name}</span>
    </div>
  </div>
</div>
</a>
    `.trim();
  }

  // Copia el código generado al portapapeles
  copyToClipboard() {
    navigator.clipboard.writeText(this.generatedCode).then(() => {
      this.copySuccess = true;
      // Oculta el mensaje de éxito después de 3 segundos
      setTimeout(() => this.copySuccess = false, 3000);
    }).catch(err => {
      console.error('Error copiando el texto: ', err);
    });
  }
  sendEmail(): void {
    // Validación de campos
    // if (!this.email.subject || !this.email.recipient || !this.email.senderMail) {
    //   alert('Por favor, completa todos los campos antes de enviar.');
    //   return;
    // }

    // Exportar el contenido del editor
    this.exportEditorHtml((editorContent: string) => {
      // Aquí, si el backend ya se encarga de agregar el doctype y el head,
      // puedes enviar solo el contenido central.
      this.email.content = editorContent;
      this.email.senderMail = this.selectedAccount; // Asume que lo seleccionaste previamente
      this.email.campaign.subcat = this.selectedSubcatCampaign
      this.email.campaign.sector = this.sector
      this.email.campaign.ubication = this.cityCtrl.value


      // Envía el correo a través del servicio
      this.userData.sendEmail(this.email).subscribe((data: any) => {
        alert('Correo enviado correctamente.');
      });
      this.dialogRef.close(this.email);
    });
  }
}
